module.exports = __webpack_public_path__ + "media/images/nominations-bg-684353e98919e1cac1ba259ede375782.png";